import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import logo from "../assets/University Officials/image10.jpg"; // सही इमेज पथ डालें

const ControllerofExaminations = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
                        <img
                            src={logo}
                            alt="परीक्षा नियंत्रक"
                            className="img-fluid rounded-circle shadow"
                            style={{
                                height: '200px',
                                width: '200px',
                                objectFit: 'cover',
                                border: '5px solid #0d6efd' // primary border
                            }}
                        />
                    </div>
                    <div className="col-md-8">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                परीक्षा नियंत्रक
                            </CardTitle>
                            <CardText className="fs-5">
                                <strong>प्रो. भाग सिंह बोदला</strong><br />
                                परीक्षा नियंत्रक
                            </CardText>
                            <hr />
                            <CardText className="mt-3">
                                <strong>संपर्क:</strong> 94661-74087<br />
                                <strong>ई-मेल:</strong> <a href="mailto:coe@mvsu.ac.in">coe@mvsu.ac.in</a><br />
                                <strong>अस्थाई परिसर:</strong><br />
                                डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय,<br />
                                जगदीशपुरा, कैथल (हरियाणा) – 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default ControllerofExaminations;
